class SectionBorder extends HTMLElement {
  connectedCallback() {
    this.tabWidth = parseInt(this.dataset.tabWidth ?? 58);
    this.tabClone = this.querySelector('[data-tab-clone]').cloneNode(true);
    this.tabClone.removeAttribute('[data-tab-clone]');
    this.fillBorder();
    window.addEventListener(
      'resize',
      debounce(() => {
        this.fillBorder()
      },
      300).bind(this)
    )
  }

  fillBorder() {
    this.sectionWidth = this.getBoundingClientRect().width;
    let tabsRequired = Math.ceil(this.sectionWidth / this.tabWidth);
    if(!(tabsRequired % 2)) {
      tabsRequired++;
    }
    this.innerHTML = '';
    for(let i = 0; i < tabsRequired; i++) {
      this.append(this.tabClone.cloneNode(true))
    }
  }
}

customElements.define('section-border', SectionBorder);